/**
 * E-Commerce Branding and Content Configuration
 * Customize this file to quickly rebrand the storefront for different projects.
 */
export const ECOMMERCE_BRANDING = {
    // General Site branding
    defaultSiteTitle: "OMNIVASO Store",
    footerCopyright: "© OMNIVASO. Custom E-Commerce Engine.",

    // Shop Page headers
    shopHeroHeading: "OMNIVASO Online Store",
    shopHeroSubheading: "Browse our official merchandise, digital items, and featured products.",

    // Product details copy
    productInquiryText: "For custom bulk orders or special inquiries, please get in touch with our team.",

    // Cart notifications & messaging
    orderSuccessTitle: "Transaction Processed!",
    orderSuccessMessage: "Thank you for your order. Please contact us for shipping updates.",
    checkoutFailedMessage: "Checkout failed. Please check payment details.",
    checkoutErrorMessage: "Error processing checkout. Please try again.",
    emptyCartMessage: "Your shopping cart is currently empty.",
    inquiryOnlyNotice: "This item requires a custom commission or price inquiry. Please use the Inquiry form.",
    outOfStockNotice: "Sorry, only {stock} items are in stock.",

    // Browser local storage key
    cartStorageKey: "omnivaso_store_cart"
};

/**
 * Default Outgoing Email Notification Template Settings
 */
export const DEFAULT_EMAIL_TEMPLATE = {
    from_name: "OMNIVASO Store",
    from_email: "",
    subject: "Order Confirmation - Order #{order_id}",
    header_title: "Transaction Processed!",
    header_subtitle: "Thank you for your order. Please contact us for shipping updates.",
    body_intro: "We have received your order and your payment has been processed. Here is your transaction summary:",
    footer_text: "Thank you for your business! If you have any questions about your order, please reply to this email."
};

/**
 * Nav links to be injected into the global header by the engine's config merge.
 * Modify this array to control which e-commerce pages appear in the site navigation.
 */
export const ECOMMERCE_NAV_LINKS = [
    { text: "Shop", url: "/shop" },
    { text: "Cart 🛒", url: "/cart" }
];

/**
 * Helper to check if the E-Commerce module is enabled and unlocked (paywall cleared).
 */
export const isEcommerceUnlocked = (config = {}) => {
    const isDemo = typeof window !== 'undefined' && (
        localStorage.getItem('omnivaso_demo_mode') === 'true' ||
        (typeof window.location !== 'undefined' && window.location.search.includes('demo=true'))
    );
    const mod = config?.modules?.ecommerce;
    if (!mod || mod.enabled !== true) {
        return isDemo ? true : false;
    }
    if (mod.isLocked === true && !mod.licenseKey) {
        return isDemo ? true : false;
    }
    return true;
};
